<app-initialization class="w-full h-full" (close)="_onAppInitialized($event)"></app-initialization>

@if (initialized) {
	<router-outlet></router-outlet>
}
